import client from "apolloClient"
import getDiscounts from "gql/discount/queries/getDiscounts"

export default ({ pagination, filter }) => async () => {
    try {
        const response = await client.query({
            query: getDiscounts,
            variables: {
                pagination, filter
            }
        }).then(response => response.data.getDiscounts.result)

        return response
        
    } catch (error) {
        console.error("Err in getDiscounts", error)
    }
}